<div class="field">
    <label soho-label>{{ 'Field' | translate}}</label>

    <!--input
            soho-lookup
            [click]="onGetFieldQualifier"
            soho-alert
            soho-trackdirty
            soho-busyindicator blockUI="true" displayDelay="0"
            [attr.id]="id"
            (keydown)="false"
            [(ngModel)]="qualifier.text"
    />-->
    <div class="flex-lookup-field">
    <input
            type="text" name="name" [id]="fieldId"
            soho-autocomplete [source]="autoCompleteSource" [filterMode]="null" (selected)="onAutoCompleteSelected($event)" (change)="onChange($event)" (focusout)="validateField()"
            soho-alert attr.data-validate="required"
            soho-trackdirty
            title="{{qualifier.text}}"
            [(ngModel)]="qualifier.text">

    <button title="{{'Search' | translate}}" soho-button="icon" icon="search" (click)="onGetFieldQualifier($event)"></button>
    </div>
</div>
<div #modalPlaceholder id="modalPlaceholder"></div>
